<template>
  <div class="cf-card cf-flex cf-flex--column cf-flex--gap-24">
    <div class="cf-flex cf-flex--column cf-flex--gap-12">
      <h3 class="cf-title cf-title--3">
        Send Receipt
      </h3>

      <div class="cf-flex cf-flex--column cf-flex--gap-8">
        <p class="cf-subtitle cf-subtitle--2">
          Would you like to send your receipt to another email address?
        </p>

        <validated-form
          name="sendReceipt"
          @valid-submit="sendReceiptFormHandler"
        >
          <div class="cf-flex cf-flex--row cf-flex--justify-space-between cf-flex--gap-16 cf-mobile-column">
            <cf-text-input
              v-model="email"
              type="email"
              label="Email"
              name="email"
              :validations="{
                required: true
              }"
            />

            <button
              class="cf-button cf-button--primary cf-button--md cf-button--mobile-fill cf-align-self-center"
              type="submit"
              :class="{
                'cf-button--loading': $store.state.receipt.receiptIsSending
              }"
            >
              Send
            </button>
          </div>
        </validated-form>
      </div>
    </div>

    <cf-survey-link
      v-if="isSurveyEnabled"
      :order="receipt"
    />

    <cf-app-download-badges
      v-if="merchant.options.showAppDownloadButtonsOnReceipt && !Boolean(merchant.options.showAppDownloadButtonsOnFooter)"
      :title="content.ReceiptStandard.metadata.appDownloadText"
    />
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfTextInput from '@/view/components/shared/cf-text-input/index.vue';

  import CfAppDownloadBadges from '@/view/components/globals/cf-app-download-badges/index.vue';
  import CfSurveyLink from '@/view/components/globals/cf-survey-link/index.vue';


  export default {
    name: 'RequestEmailedReceiptForm',

    components: {
      CfTextInput,
      CfAppDownloadBadges,
      CfSurveyLink
    },

    props: {
      receipt: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        email: null
      };
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('merchant', ['merchant']),

      isSurveyEnabled() {
        return this.merchant.features['enable-surveys'];
      }
    },

    methods: {
      sendReceiptFormHandler() {
        this.$store.dispatch('receipt/sendReceipt', {
          communicationName: 'CustomerOrderAheadReceipt',
          email: this.email,
          receiptToken: this.$route.params.receiptToken
        });
      }
    }
  };
</script>
